import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { StatusComponent } from '@modules/shared/status/status.component';
import { Telemonitoring } from '@pixacare/dtos';
import { DialogService } from '@services/dialog.service';
import { ActionStatus } from '@pixacare/shared';
import { Status } from '@shared/models/enums/status.enum';
import { TuiButton } from '@taiga-ui/core';
import { TelemonitoringSendTutorialComponent } from '../telemonitoring-send-tutorial/telemonitoring-send-tutorial.component';

@Component({
  selector: 'pxc-telemonitoring-request-result',
  imports: [StatusComponent, TuiButton, TranslocoDirective],
  templateUrl: './telemonitoring-request-result.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelemonitoringRequestResultComponent {
  @Input() state: {
    message?: string;
    data?: Telemonitoring;
    status: ActionStatus;
  };

  @Output() closeDialog = new EventEmitter<void>();

  Status = Status;
  ActionStatus = ActionStatus;

  private readonly dialogService = inject(DialogService);
  private readonly translocoService = inject(TranslocoService);

  sendTutorial(): void {
    if (!this.state.data) {
      return;
    }

    this.closeDialog.emit();
    this.dialogService
      .openComponent(TelemonitoringSendTutorialComponent, {
        label: this.translocoService.translate('Envoyer le tutoriel'),
        data: {
          telemonitoring: this.state.data,
        },
      })
      .subscribe();
  }

  closeModal(): void {
    this.closeDialog.emit();
  }
}
